import React, { FunctionComponent, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { SelectionChangedEvent, ColGroupDef, ColDef } from '@ag-grid-enterprise/all-modules';
import { DistributorConfiguration } from 'data/distributorConfiguration/distributorConfiguration.types';
import CommonGrid from 'shared/commonGrid';
import { ROWSELECTION } from 'shared/commonGrid/grid-enums';
import ActionMenuCellRenderer from 'shared/commonGrid/action-menu-cell-renderer';
import { GridSettings } from 'data/types';
import ActionMenus from 'components/ActionMenus';
import DistributorGridActionMenu from '../DistributorGridActionMenu';

interface Props {
  data: DistributorConfiguration[]
  hasPrivilegeToView: boolean
  hasPrivilegesToCreate: boolean
  hasPrivilegeToDelete: boolean
  noResults: boolean,
  beforeLogout: boolean,
  lastUpdatedAt: Date | undefined,
  columnDefs: (ColGroupDef | ColDef)[],
  selectedDistributorConfiguration: DistributorConfiguration
  onRefresh: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  onCreateNew: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  onGetGridSettings: () => any
  onSelectionChanged: (event: SelectionChangedEvent) => void
  onSaveGridSettings: (gridSettings: GridSettings) => void
  onSelectItemMenuAction: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void
  onShowActionMenuItem: (menuId: string, data: DistributorConfiguration[]) => void
  onDeleteRow: () => void
  onEdit: () => void
  onCopy: () => void
}

const DistributorGrid: FunctionComponent<Props> = ({
  hasPrivilegesToCreate,
  hasPrivilegeToDelete,
  hasPrivilegeToView,
  data = [],
  noResults,
  beforeLogout,
  lastUpdatedAt,
  columnDefs,
  selectedDistributorConfiguration,
  onDeleteRow,
  onEdit,
  onCreateNew,
  onRefresh,
  onSelectionChanged,
  onSaveGridSettings,
  onGetGridSettings,
  onShowActionMenuItem,
  onSelectItemMenuAction,
  onCopy,
}: Props) => {

  const { t } = useTranslation();

  return (
    <div className="grid-container" style={{ height: 'inherit' }}>
      <CommonGrid
        createNewText={t('ss8Distributors.grid.createNew')}
        pagination
        enableBrowserTooltips
        rowSelection={ROWSELECTION.SINGLE}
        hasPrivilegeToCreateNew={hasPrivilegesToCreate}
        hasPrivilegeToDelete={hasPrivilegeToDelete}
        hasPrivilegetoView={hasPrivilegeToView}
        rowData={data}
        noResults={noResults}
        isBeforeLogout={beforeLogout}
        columnDefs={columnDefs}
        actionMenuClass={DistributorGridActionMenu}
        handleCreateNew={onCreateNew}
        onRefresh={onRefresh}
        onSelectionChanged={onSelectionChanged}
        showActionMenuItem={onShowActionMenuItem}
        onActionMenuItemClick={onSelectItemMenuAction}
        saveGridSettings={onSaveGridSettings}
        getGridSettingsFromServer={onGetGridSettings}
        lastUpdatedAt={lastUpdatedAt}
      >
        <ActionMenus
          name={selectedDistributorConfiguration?.name}
          deleteTitle={t('ss8Distributors.deletePopup.title')}
          deleteMessage={[
            <Fragment key="1">
              {t('ss8Distributors.deletePopup.message', { name: selectedDistributorConfiguration?.name })}
            </Fragment>,
            <Fragment key="2">
              <br />
              <br />
            </Fragment>,
            <Fragment key="3">
              {t('ss8Distributors.deletePopup.description')}
            </Fragment>,
          ]}
          hasPrivilegesToCreate={hasPrivilegesToCreate}
          hasPrivilegeToDelete={hasPrivilegeToDelete}
          onEdit={onEdit}
          onCopy={onCopy}
          onDelete={onDeleteRow}
        />
      </CommonGrid>
    </div>
  );
};

export default DistributorGrid;
